export const catalog_matrix = [
  {form_key:'new_doctor_id', catalog_key:'doctors'},
  //{form_key:'responsible_id', catalog_key:'none', propname:'users'},
]